<template>
  <div>
    <v-alert v-show="true" color="primary" value="true" outline>
      Ces réglages affectent la fonctionnalité SMS (notifications par texto). Ses réglages sont indépendants des réglages du "widget" et des autres fonctionnalités.
    </v-alert> 
    <!-- Indique si la licence n'a pas l'option Callback -->
    <v-alert v-show="alert" color="secondary" icon="warning" value="true" outline>
      L'option Alertes SMS est désactivée. Vous ne pourrez pas sauvegarder. <code>{{ $store.state._Sites.siteSelected.LIC_URL }}</code>
    </v-alert>
    <div>
        <!-- Chargement -->
        <div v-if="loadingGet" class="text-xs-center">
          <v-progress-circular indeterminate class="primary--text" :size="100" :width="1"></v-progress-circular>
        </div>
        <!-- Formulaire -->
        <v-card v-else class="mb-3">
          <v-card-text>
            <v-layout row>
              <v-flex xs12>
                <v-switch 
                  :label="onOff ? 'ALERTES SMS ON' : 'ALERTES SMS OFF'" 
                  v-model="onOff"
                  light
                  color="primary"
                ></v-switch>
              </v-flex>
            </v-layout>
	  	  <v-layout row>
              <v-flex xs12>
                <v-text-field 
                  v-model="numero"
                  label="Numéro de mobile" 
                  required
                  v-validate="'required'"
                ></v-text-field>
              </v-flex>
            </v-layout>
            <v-layout row>
              <v-flex xs12>
                <v-switch 
                  :label="c2c ? 'Activé pour les callbacks entrants ON' : 'Activé pour les callbacks entrants OFF'" 
                  v-model="c2c"
                  light
                  color="primary"
                ></v-switch>
              </v-flex>
            </v-layout>
            <v-layout row>
              <v-flex xs12>
                <v-switch 
                  :label="c2c_missed ? 'Activé pour les callbacks ratés ON' : 'Activé pour les callbacks ratés OFF'" 
                  v-model="c2c_missed"
                  light
                  color="primary"
                ></v-switch>
              </v-flex>
            </v-layout>
            <v-layout row>
              <v-flex xs12>
                <v-switch 
                  :label="chat ? 'Activé pour les chats entrants ON' : 'Activé pour les chats entrants OFF'" 
                  v-model="chat"
                  light
                  color="primary"
                ></v-switch>
              </v-flex>
            </v-layout>
            <v-layout row>
              <v-flex xs12>
                <v-switch 
                  :label="abs ? 'Activé pour les messages en absence ON' : ' Activé pour les messages en absenceOFF'" 
                  v-model="abs"
                  light
                  color="primary"
                ></v-switch>
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>
      
        <!-- Validation du formulaire -->
        <div class="text-xs-right">
          <v-btn
            color="primary"
            :block="$vuetify.breakpoint.xsOnly"
            :loading="loadingPost"
            @click.native="postOptions()"
            :disabled="alert"
          >{{ $t('save') | cap }}<v-icon dark right>save</v-icon>
          </v-btn>
        </div>
    </div>
    <!-- dialog progress bar installation -->
    <wz-dialog-progress
      @fermeDialogProgress="fermeDialogProgress"
      :dialogProgress="dialogProgress"
      :etape=7
    >
    </wz-dialog-progress>
  </div>
</template>

<script>
export default {
  data () {
    return {
      alert: false,
      lang: null,
      onOff: false,
      numero: '',
      c2c: '0',
      c2c_missed: '0',
      chat: '0',
      abs: '0',
      // loaders
      loadingGet: false,
      loadingPost: false,
      dialogProgress: false
    }
  },

  mounted () {
    this.getOptions()
    if (!this.$cookie.get('blockInstallProgress') && this.$store.state._User.ongoingTuto) {
      this.openDialogProgress()
    }
  },

  created () {
    /* eslint-disable */
    if (typeof (defautMotif) !== 'undefined') {
      defautMotif = 'settings_sms'
    }
    else {
      setTimeout (function () {
        if (typeof (defautMotif) !== 'undefined') {
          defautMotif = 'settings_sms'
        }
      }, 800);
    }
    /* eslint-enable */
  },

  computed: {
  },

  methods: {
    getOptions () {
      this.numero = this.$store.state._Sites.siteSelected.LIC_SMS_PHONE
      if (
        this.$store.state._Sites.siteSelected.LIC_SMS_ACTIVATED !== '1'
      ) {
        this.alert = true
        return
      }
      this.alert = false
      this.loadingGet = true
      this.axios
        .get(
          'get/settings_sms.php?desk=' +
            this.$store.state._Sites.siteSelected.LIC_DSK_ID
        )
        .then(response => {
          this.onOff = response.data.DSK_SMS_ONOFF === '1'

          let features = JSON.parse(response.data.DSK_SMS_FEATURES) || {}

          /* {"chat":"1","c2c":"0","c2c_missed":"0","abs"0"} */
          this.chat = features.chat === '1'
          this.c2c = features.c2c === '1'
          this.c2c_missed = features.c2c_missed === '1'
          this.abs = features.abs === '1'
        })
        .catch(_ => {})
        .then(_ => {
          this.loadingGet = false
        })
    },

    postOptions () {
      // Données modifiées et à renvoyer
      let dataToPost = new window.FormData()

      dataToPost.append(
        'DSK_ID',
        this.$store.state._Sites.siteSelected.LIC_DSK_ID
      )
      dataToPost.append(
        'LIC_KEY',
        this.$store.state._Sites.siteSelected.LIC_KEY
      )
      this.$store.state._Sites.siteSelected.LIC_SMS_PHONE = this.numero
      dataToPost.append('LIC_SMS_PHONE', this.numero)
      dataToPost.append('DSK_SMS_ONOFF', this.onOff ? '1' : '0')
      let options = {}
      options.chat = this.chat ? '1' : '0'
      options.c2c = this.c2c ? '1' : '0'
      options.c2c_missed = this.c2c_missed ? '1' : '0'
      options.abs = this.abs ? '1' : '0'
      console.log(options)
      console.log(JSON.stringify(options))
      dataToPost.append('DSK_SMS_FEATURES', JSON.stringify(options))

      this.loadingPost = true
      this.axios
        .post('post/settings_sms.php', dataToPost, {
          headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
        })
        .then(response => {
          this.$store.dispatch('_Notifier/NEW_NOTIF', {
            message: this.$t('modifSuccess'),
            context: 'success'
          })
        })
        .catch(_ => {
          this.$store.dispatch('_Notifier/NEW_NOTIF', {
            message: this.$t('modifFailure'),
            context: 'error'
          })
        })
        .then(_ => {
          this.loadingPost = false
        })
    },
    // ---------------------------
    // close dialog Progression install
    fermeDialogProgress () {
      this.dialogProgress = false
    },
    // ---------------------------
    // Ouvre la dialogueBox de progression de l'installation
    openDialogProgress () {
      this.dialogProgress = true
    }
  },

  watch: {
    '$store.state._Sites.siteSelected': function (v) {
      this.getOptions()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/settings/Sms.vue